import React from 'react'
import { useModal } from '../useModal'
// @ts-ignore
import MathJax from 'react-mathjax2'
import { Button } from '../ui/Button'

const GainStrategyOptions = () => {
  const { closeModal } = useModal()
  return (
    <div className="px-8 py-8 flex flex-col gap-6 dark:bg-slate-700">
      <span className="font-bold text-lg text-foreground">
        Calculating Gains/Losses in Target Currency
      </span>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col text-sm text-foreground">
          <span className="pb-2">
            When calculating gains/losses for stocks in your target currency, there are a
            few options in the methodology. Neither option is the "correct" one, rather it
            varies by country and preference.
          </span>
          <span className="font-bold">Variables</span>
          <MathJax.Context input="ascii">
            <div>
              <MathJax.Node inline>{'X_(s)'}</MathJax.Node> = exchange rate on sale date
            </div>
          </MathJax.Context>
          <MathJax.Context input="ascii">
            <div>
              <MathJax.Node inline>{'X_(p)'}</MathJax.Node> = exchange rate on purchase
              date
            </div>
          </MathJax.Context>
          <span>G = gain or loss</span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-bold">Option 1: Sale Date</span>
          <span className="flex flex-row">
            Result = G *{' '}
            <MathJax.Context input="ascii">
              <div>
                <MathJax.Node inline>{'X_(s)'}</MathJax.Node>
              </div>
            </MathJax.Context>
          </span>
          <span className="text-xs font-bold">Example</span>
          <span className="text-xs">
            My target currency is Euro. I sold a stock for a gain of $100 on 1/1/2025,
            where the exchange rate was 0.9 €/$.
          </span>
          <span className="text-xs">Result = $100 * 0.9 €/$ ={'>'} €90</span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-bold">Option 2: Sale Date - Purchase Date</span>
          <span className="flex flex-row">
            Result = (proceeds *{' '}
            <MathJax.Context input="ascii">
              <div>
                <MathJax.Node inline>{'X_(s)'}</MathJax.Node>
              </div>
            </MathJax.Context>
            ) - (cost basis *{' '}
            <MathJax.Context input="ascii">
              <div>
                <MathJax.Node inline>{'X_(p)'}</MathJax.Node>
              </div>
            </MathJax.Context>
            )
          </span>
          <span className="text-xs font-bold">Example</span>
          <span className="text-xs">
            My target currency is Euro. I bought a stock for $100 on 1/1/2025 where the
            exchange rate was 0.9 €/$. I then sold the stock on 1/10/2025 for $120 where
            the exchange rate was 0.95 €/$.
          </span>
          <span className="text-xs">
            Result = ($120 * 0.95€/$) - ($100 * 0.9€/$) ={'>'} €24
          </span>
        </div>
      </div>
      <Button onClick={closeModal}>Got it!</Button>
    </div>
  )
}

export default GainStrategyOptions
